/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_fees_defaults_description = /** @type {(inputs: {}) => string} */ () => {
	return `Se aplican las comisiones base de interchange (1.44%) y FX (2%). No hay sobrecargas configuradas para esta tarjeta.`
};

const en_cards_fees_defaults_description = /** @type {(inputs: {}) => string} */ () => {
	return `Base interchange (1.44%) and FX (2%) fees apply. No card-level overrides configured.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_fees_defaults_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_fees_defaults_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_fees_defaults_description", locale)
	if (locale === "es") return es_cards_fees_defaults_description(inputs)
	return en_cards_fees_defaults_description(inputs)
};
export { cards_fees_defaults_description as "cards.fees.defaults_description" }